<template>
  <main role="main">
    <section class="mt-4 mb-5">
      <div class="container-fluid">
        <!-- Profile header -->
        <div class="row justify-content-center">
          <div class="col-md-4 mb-3">
            <div class="card shadow-sm">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-end gap-2">
                  <button type="button" class="icon-btn" @click="showQrModal = true" aria-label="Show my QR">
                    <i class="fas fa-qrcode"></i>
                  </button>
                  <router-link to="/update-profile" class="icon-btn" aria-label="Edit profile">
                    <i class="fas fa-edit"></i>
                  </router-link>
                </div>

                <div class="user-profile d-flex flex-column flex-md-row align-items-center gap-3">
                  <div class="profile-image">
                    <img v-no-right-click :src="user.user_img || '/assets/img/av.png'" alt="Profile picture" class="img-fluid rounded-circle" />
                  </div>
                  <div class="profile-info pl-3 text-md-start">
                    <h4 class="mb-1 fw-bold">{{ user.name }}</h4>
                    <p class="small text-muted mb-0">@{{ user.username }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="row justify-content-center">
          <div class="col-md-4">
            <div class="sticky">
              <div class="card shadow-sm">
                <div class="card-body settings-card-body">
                  <div class="settings-section">
                    <h6 class="section-title">Account</h6>
                    <div class="list-group settings-list">
                      <router-link to="/my-contacts" class="list-group-item list-group-item-action d-none">
                        <div class="d-flex align-items-center">
                          <img v-no-right-click src="/assets/icons/terms.svg" alt="" class="img-fluid rounded" />
                          <div class="pl-2">
                            <h6 class="mb-0">My Contacts</h6>
                            <small class="text-muted">Manage saved guests and friends.</small>
                          </div>
                        </div>
                      </router-link>

                      <router-link to="/enquiries-list" class="list-group-item list-group-item-action">
                        <div class="d-flex align-items-center">
                          <img v-no-right-click src="/assets/icons/terms.svg" alt="" class="img-fluid rounded" />
                          <div class="pl-2">
                            <h6 class="mb-0">Enquiries List</h6>
                            <small class="text-muted">Review leads and outreach.</small>
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>

                  <div class="settings-section">
                    <h6 class="section-title">Sharing & Referrals</h6>
                    <div class="list-group settings-list">
                      <button type="button" class="list-group-item list-group-item-action text-left" @click="showInviteModal = true">
                        <div class="d-flex align-items-center">
                          <img v-no-right-click src="/assets/icons/InviteFriends.svg" alt="" class="img-fluid rounded" />
                          <div class="pl-2">
                            <h6 class="mb-0">Invite Friends</h6>
                            <small class="text-muted">Share the app with your circle.</small>
                          </div>
                        </div>
                      </button>

                      <button type="button" class="list-group-item list-group-item-action text-left" @click="showInviteBusinessModal = true">
                        <div class="d-flex align-items-center">
                          <img v-no-right-click src="/assets/icons/InviteBusiness.svg" alt="" class="img-fluid rounded" />
                          <div class="pl-2">
                            <h6 class="mb-0">Invite Business</h6>
                            <small class="text-muted">Send the referral link to partners.</small>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>

                  <div class="settings-section">
                    <h6 class="section-title">Security</h6>
                    <div class="list-group settings-list">
                      <router-link to="/change-password" class="list-group-item list-group-item-action">
                        <div class="d-flex align-items-center">
                          <img v-no-right-click src="/assets/icons/change-password.svg" alt="" class="img-fluid rounded" />
                          <div class="pl-2">
                            <h6 class="mb-0">Change Password</h6>
                            <small class="text-muted">Update your login credentials.</small>
                          </div>
                        </div>
                      </router-link>

                      <button type="button" class="list-group-item list-group-item-action text-left" @click="logout">
                        <div class="d-flex align-items-center">
                          <img v-no-right-click src="/assets/icons/logout.svg" alt="" class="img-fluid rounded" />
                          <div class="pl-2">
                            <h6 class="mb-0">Logout</h6>
                            <small class="text-muted">Sign out of this device.</small>
                          </div>
                        </div>
                      </button>

                      <button type="button" class="list-group-item list-group-item-action text-left danger" @click="deleteAccount">
                        <div class="d-flex align-items-center">
                          <img v-no-right-click src="/assets/icons/delete-account.svg" alt="" class="img-fluid rounded" />
                          <div class="pl-2">
                            <h6 class="mb-0">Delete Account</h6>
                            <small class="text-muted">Permanently remove your data.</small>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>

                  <div class="settings-section">
                    <h6 class="section-title">Support & Legal</h6>
                    <div class="list-group settings-list">
                      <a href="https://invi8.net/support" target="_blank" rel="noopener" class="list-group-item list-group-item-action">
                        <div class="d-flex align-items-center">
                          <img v-no-right-click src="/assets/icons/support.svg" alt="" class="img-fluid rounded" />
                          <div class="pl-2">
                            <h6 class="mb-0">Support</h6>
                            <small class="text-muted">Browse FAQs or reach out.</small>
                          </div>
                        </div>
                      </a>

                      <a href="https://invi8.net/terms-conditions" target="_blank" rel="noopener" class="list-group-item list-group-item-action">
                        <div class="d-flex align-items-center">
                          <img v-no-right-click src="/assets/icons/terms.svg" alt="" class="img-fluid rounded" />
                          <div class="pl-2">
                            <h6 class="mb-0">Terms of Use</h6>
                            <small class="text-muted">Understand the rules of the platform.</small>
                          </div>
                        </div>
                      </a>

                      <a href="https://invi8.net/privacy-policy" target="_blank" rel="noopener" class="list-group-item list-group-item-action">
                        <div class="d-flex align-items-center">
                          <img v-no-right-click src="/assets/icons/privacy.svg" alt="" class="img-fluid rounded" />
                          <div class="pl-2">
                            <h6 class="mb-0">Privacy Policy</h6>
                            <small class="text-muted">How we handle your information.</small>
                          </div>
                        </div>
                      </a>

                      <button type="button" class="list-group-item list-group-item-action text-left" @click="openAppsModal">
                        <div class="d-flex align-items-center">
                          <img v-no-right-click src="/assets/icons/more-apps.svg" alt="" class="img-fluid rounded" />
                          <div class="pl-2">
                            <h6 class="mb-0">More Amplifier Apps</h6>
                            <small class="text-muted">Discover companion tools.</small>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  </main>

  <!-- Invite Friends Modal -->
  <div
    v-if="showInviteModal"
    class="modal-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="inviteFriendsTitle"
    @click.self="showInviteModal = false"
  >
    <div class="modal-card">
      <button type="button" class="modal-close" @click="showInviteModal = false" aria-label="Close dialog">
        <span aria-hidden="true">&times;</span>
      </button>
      <h5 id="inviteFriendsTitle" class="modal-title">Invite Friends</h5>
      <p class="text-muted mb-3">Share this message with your friends:</p>
      <div class="form-group">
        <textarea class="form-control" rows="4" readonly :value="inviteText" style="white-space:pre-wrap;"></textarea>
      </div>
      <div class="modal-actions">
        <button class="btn btn-outline-secondary btn-sm" type="button" @click="copyInviteText">
          Copy Text
        </button>
        <button class="btn btn-secondary btn-sm" type="button" @click="showInviteModal = false">
          Close
        </button>
      </div>
    </div>
  </div>

  <!-- My QR Modal -->
  <div
    v-if="showQrModal"
    class="modal-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="qrModalTitle"
    @click.self="showQrModal = false"
  >
    <div class="modal-card modal-card--wide qr-card">
      <button type="button" class="modal-close" @click="showQrModal = false" aria-label="Close dialog">
        <span aria-hidden="true">&times;</span>
      </button>
      <h5 id="qrModalTitle" class="modal-title mb-3">My QR</h5>
      <div class="qr-header">
        <img v-no-right-click :src="user.user_img || '/assets/img/av.png'" alt="Profile picture" class="qr-avatar" />
        <div class="qr-meta">
          <div class="qr-name">{{ user.name || 'User' }}</div>
          <div class="qr-handle" v-if="user.username">@{{ user.username }}</div>
          <div class="qr-sub" v-else-if="user.email">{{ user.email }}</div>
          <div class="qr-sub" v-if="contactLine">{{ contactLine }}</div>
        </div>
      </div>

      <div class="qr-body">
        <div class="qr-image-wrap">
          <img v-no-right-click :src="user.qrcode_image || '/assets/icons/terms.svg'" alt="QR Code" class="qr-image" />
        </div>
        <div class="qr-info">
          <div class="qr-row" v-if="user.referral_code">
            <span class="qr-label">Referral Code</span>
            <div class="qr-value">{{ user.referral_code }}</div>
            <button class="btn btn-outline-secondary btn-sm" @click="copyValue(user.referral_code)">Copy</button>
          </div>
          <div class="qr-row" v-if="user.profile_link">
            <span class="qr-label">Profile Link</span>
            <div class="qr-value text-truncate">{{ user.profile_link }}</div>
            <button class="btn btn-outline-secondary btn-sm" @click="copyValue(user.profile_link)">Copy</button>
          </div>
        </div>
      </div>

      <div class="modal-actions">
        <button type="button" class="btn btn-secondary btn-sm" @click="showQrModal = false">Close</button>
      </div>
    </div>
  </div>

  <!-- Invite Business Modal -->
  <div
    v-if="showInviteBusinessModal"
    class="modal-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="inviteBusinessTitle"
    @click.self="showInviteBusinessModal = false"
  >
    <div class="modal-card">
      <button type="button" class="modal-close" @click="showInviteBusinessModal = false" aria-label="Close dialog">
        <span aria-hidden="true">&times;</span>
      </button>
      <h5 id="inviteBusinessTitle" class="modal-title">Invite Business</h5>
      <p class="text-muted mb-3">Share this message with your business partners:</p>
      <div class="form-group">
        <textarea class="form-control" rows="4" readonly :value="inviteBusinessText" style="white-space:pre-wrap;"></textarea>
      </div>
      <div class="modal-actions">
        <button class="btn btn-outline-secondary btn-sm" type="button" @click="copyInviteBusinessText">
          Copy Text
        </button>
        <button class="btn btn-secondary btn-sm" type="button" @click="showInviteBusinessModal = false">
          Close
        </button>
      </div>
    </div>
  </div>

  <!-- More Apps Modal (driven by moreApps() API) -->
  <div
    v-if="showAppsModal"
    class="modal-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="moreAppsTitle"
    @click.self="showAppsModal = false"
  >
    <div class="modal-card modal-card--wide">
      <button type="button" class="modal-close" @click="showAppsModal = false" aria-label="Close dialog">
        <span aria-hidden="true">&times;</span>
      </button>
      <h5 id="moreAppsTitle" class="modal-title">More Amplifier Apps</h5>
      <div class="modal-scroll">
        <div v-if="appsLoading" class="text-center text-muted py-4">
          <div class="spinner-border spinner-border-sm mr-2"></div> Loading…
        </div>

        <div v-else class="list-group">
          <div
            v-for="app in apps"
            :key="app.id"
            class="list-group-item d-flex align-items-center justify-content-between"
          >
            <div class="d-flex align-items-center">
              <img v-no-right-click :src="app.image" class="rounded mr-3" style="width:44px;height:44px;object-fit:cover" />
              <div>
                <div class="font-weight-semibold">{{ app.title }}</div>
                <div class="small text-muted">{{ app.sub_title }}</div>
              </div>
            </div>
            <div class="store-buttons">
              <a
                v-if="app.url_android"
                :href="app.url_android"
                target="_blank"
                rel="noopener"
                class="store-btn store-btn--android"
              >
                <i class="fab fa-android mr-1"></i> Android
              </a>
              <span v-else class="store-btn store-btn--disabled">
                <i class="fab fa-android mr-1"></i> Android
              </span>

              <a
                v-if="app.url_ios"
                :href="app.url_ios"
                target="_blank"
                rel="noopener"
                class="store-btn store-btn--ios"
              >
                <i class="fab fa-apple mr-1"></i> iOS
              </a>
              <span v-else class="store-btn store-btn--disabled">
                <i class="fab fa-apple mr-1"></i> iOS
              </span>
            </div>
          </div>

          <div v-if="!apps.length" class="text-center text-muted py-3">
            No app links available.
          </div>
        </div>
      </div>

      <div class="modal-actions mt-3">
        <button type="button" class="btn btn-secondary btn-sm" @click="showAppsModal = false">Close</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useSessionStore } from '@/stores/session'
import api from '@/services/api'
import { useHead } from '@vueuse/head'
import Swal from 'sweetalert2'

const router = useRouter()
const session = useSessionStore()

const showInviteModal = ref(false)
const showInviteBusinessModal =  ref(false)
const showAppsModal = ref(false)
const showQrModal = ref(false)
const appsLoading = ref(false)
const apps = ref([])               // will hold moreApps() API result

const user = reactive({
  id: '',
  name: '',
  username: '',
  email: '',
  phone: '',
  phone_code: '',
  qrcode_image: '',
  qrcode: '',
  referral_code: '',
  profile_link: '',
})

/* ---------------- meta ---------------- */
useHead({
  title: 'My Account - Invi8',
  meta: [
    { name: 'description', content: 'Account settings for Invi8.' },
    { name: 'keywords', content: 'settings, amplifier, invites' },
  ],
})

/* ---------------- utils ---------------- */
const toast = (msg, icon='success') =>
  Swal.fire({ toast:true, position:'top-end', icon, title:msg, timer:2000, showConfirmButton:false })

/* ---------------- computed ---------------- */
const inviteText = computed(() => user.invite_social_link || user.profile_link || user.qr_app_Download || '')
/* ---------------- computed ---------------- */
const inviteBusinessText = computed(() => user.business_referal_link || user.profile_link || user.qr_app_Download || '')
const contactLine = computed(() => {
  if (!user.phone && !user.phone_code) return ''
  return `${user.phone_code || ''} ${user.phone || ''}`.trim()
})

/* ---------------- actions ---------------- */
const copyInviteText = async () => {
  const text = inviteText.value || ''
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
    } else {
      const el = document.createElement('textarea')
      el.value = text
      el.style.position = 'fixed'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    }
    toast('Copied to clipboard')
  } catch (e) {
    console.error('copy failed', e)
    toast('Copy failed', 'error')
  }
}


const copyInviteBusinessText = async () => {
  const text = inviteBusinessText.value || ''
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
    } else {
      const el = document.createElement('textarea')
      el.value = text
      el.style.position = 'fixed'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    }
    toast('Copied to clipboard')
  } catch (e) {
    console.error('copy failed', e)
    toast('Copy failed', 'error')
  }
}

const copyValue = async (text) => {
  const val = String(text || '').trim()
  if (!val) return
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(val)
    } else {
      const el = document.createElement('textarea')
      el.value = val
      el.style.position = 'fixed'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    }
    toast('Copied to clipboard')
  } catch (e) {
    console.error('copy failed', e)
    toast('Copy failed', 'error')
  }
}

const openAppsModal = async () => {
  showAppsModal.value = true
  if (apps.value.length) return // already loaded once

  appsLoading.value = true
  try {
    // moreApps() has no params; adjust if your API expects some

    const fd = new FormData();
    fd.append("type", 'invite');
    const res = await api.moreApps(fd)
    const list = Array.isArray(res?.data?.data) ? res.data.data : []

    // Normalize & filter out empty entries
    apps.value = list
      .map(a => ({
        id: a.id,
        title: a.title || a.name || 'Amplifier App',
        sub_title: a.sub_title || '',
        image: a.image || 'https://dummyimage.com/100x100/e9ecef/adb5bd.png&text=App',
        url_ios: (a.url_ios || '').startsWith('http') ? a.url_ios : '',
        url_android: (a.url_android || '').startsWith('http') ? a.url_android : '',
      }))
      .filter(a => a.url_ios || a.url_android)
  } catch (e) {
    console.error('moreApps() failed', e)
    toast('Failed to load apps', 'error')
  } finally {
    appsLoading.value = false
  }
}

const logout = () => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'You will be logged out.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, logout',
    cancelButtonText: 'Cancel'
  }).then((result) => {
    if (result.isConfirmed) {
      session.logout()
      router.push('/login')
      Swal.fire('Logged Out', 'You have been logged out.', 'success')
    }
  })
}

const deleteAccount = () => {
  Swal.fire({
    title: 'Delete Account?',
    text: 'This action cannot be undone!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it',
    cancelButtonText: 'Cancel'
  }).then((result) => {
    if (result.isConfirmed) {
      // TODO: call your delete account API
      Swal.fire('Deleted!', 'Your account has been deleted.', 'success')
    }
  })
}

/* ---------------- data fetch ---------------- */
const fetchProfile = async () => {
  if (!session.userId) return
  try {
    const formData = new FormData()
    formData.append('id', session.userId)
    const { data } = await api.getProfileApi(formData)
    if (data.status === 'ok' && data?.data?.[0]) {
      Object.assign(user, data.data[0])
    }
  } catch (error) {
    console.error('Profile fetch failed', error)
  }
}

/* ---------------- lifecycle ---------------- */
onMounted(() => {
  session.loadUser()
  fetchProfile()
})
watch(() => session.userId, fetchProfile)
</script>

<style scoped>
.settings-card-body {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.settings-section {
  padding-bottom: 18px;
  border-bottom: 1px solid #f5f5f5;
}

.settings-section:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.section-title {
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6c757d;
  margin-bottom: 10px;
}

.settings-list .list-group-item {
  border: 1px solid #f1f1f1;
  border-radius: 14px;
  margin-bottom: 10px;
  padding: 14px 16px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.settings-list .list-group-item:last-child {
  margin-bottom: 0;
}

.settings-list .list-group-item-action:hover {
  border-color: #dee2e6;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
}

.settings-list h6 {
  font-size: 0.95rem;
  margin-bottom: 2px;
}

.settings-list small {
  display: block;
  font-size: 0.78rem;
}

button.list-group-item {
  background: #fff;
  width: 100%;
  text-align: left;
  border: none;
}

.list-group-item.danger h6,
.list-group-item.danger small {
  color: #dc3545;
}

.user-profile { max-width: 100%; }
.profile-image { width: 50px; height: 50px; }
.profile-image img { width: 100%; height: 100%; object-fit: cover; }

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 2000;
}

.modal-card {
  background: #fff;
  width: 100%;
  max-width: 520px;
  border-radius: 18px;
  padding: 24px;
  position: relative;
  box-shadow: 0 25px 70px rgba(15, 23, 42, 0.25);
}

.modal-card--wide {
  max-width: 640px;
}
.qr-card{
  max-width: 720px;
}

.modal-title {
  font-weight: 600;
}

.modal-close {
  border: none;
  background: transparent;
  position: absolute;
  top: 16px;
  right: 18px;
  font-size: 1.5rem;
  line-height: 1;
  color: #6c757d;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 16px;
}

.icon-btn{
  border:1px solid #e5e7eb;
  background:#f8fafc;
  border-radius:10px;
  padding:6px 10px;
  font-size:1.1rem;
  line-height:1;
  display:inline-flex;
  align-items:center;
  justify-content:center;
  transition:all .15s ease;
}
.icon-btn:hover{
  transform: translateY(-1px);
  box-shadow:0 6px 14px rgba(15,23,42,.12);
}

.modal-scroll {
  max-height: 320px;
  overflow-y: auto;
  margin-top: 12px;
  padding-right: 4px;
}

.store-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.store-btn {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  text-decoration: none;
  border: 1px solid;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.store-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 12px rgba(15, 23, 42, 0.1);
}

.store-btn--android {
  color: #198754;
  border-color: rgba(25, 135, 84, 0.4);
}

.store-btn--ios {
  color: #0d6efd;
  border-color: rgba(13, 110, 253, 0.4);
}

.store-btn--disabled {
  color: #adb5bd;
  border-color: #dee2e6;
  cursor: not-allowed;
  opacity: 0.6;
}

.qr-header{
  display:flex;
  align-items:center;
  gap:14px;
  margin-bottom:16px;
}
.qr-avatar{
  width:72px;
  height:72px;
  border-radius:16px;
  object-fit:cover;
  box-shadow:0 10px 24px rgba(15,23,42,.14);
}
.qr-meta{
  display:flex;
  flex-direction:column;
  gap:4px;
}
.qr-name{
  font-weight:700;
  font-size:1.1rem;
  color:#0f172a;
}
.qr-handle{
  color:#4338ca;
  font-weight:600;
}
.qr-sub{
  color:#6b7280;
  font-size:.9rem;
}
.qr-body{
  display:grid;
  grid-template-columns: 240px 1fr;
  gap:18px;
  align-items:center;
  max-height:60vh;
  overflow:auto;
}
.qr-image-wrap{
  background:#f8fafc;
  border:1px solid #e5e7eb;
  border-radius:18px;
  padding:12px;
  display:flex;
  align-items:center;
  justify-content:center;
}
.qr-image{
  width:100%;
  max-width:210px;
  height:auto;
  border-radius:12px;
}
.qr-info{
  display:flex;
  flex-direction:column;
  gap:10px;
}
.qr-row{
  display:grid;
  grid-template-columns: 120px 1fr auto;
  gap:10px;
  align-items:center;
  padding:10px 12px;
  border:1px solid #eef2f7;
  border-radius:12px;
  background:#f9fafb;
}
.qr-label{
  font-weight:700;
  color:#475569;
}
.qr-value{
  font-weight:600;
  color:#0f172a;
  overflow:hidden;
}

@media (min-width: 768px) {
  .profile-image { width: 100px; height: 100px; }
}
@media (min-width: 992px) {
  .profile-image { width: 100px; height: 100px; }
}
@media (max-width: 575.98px) {
  .profile-image { width: 60px; height: 60px; }
  .profile-info h4 { font-size: 1.1rem; }
}
@media (max-width: 768px){
  .qr-body{
    grid-template-columns: 1fr;
    max-height:70vh;
  }
  .qr-row{
    grid-template-columns: 1fr;
  }
}
</style>
